const rotate = function(cx, cy, x, y, angle, anticlock_wise = false) {
    let radians
    if(angle == 0){
      return {x:parseFloat(x), y:parseFloat(y)};
    }
    if(anticlock_wise){
      radians = (Math.PI / 180) * angle;
    }else{
      radians = (Math.PI / -180) * angle;
    }
    var cos = Math.cos(radians);
    var sin = Math.sin(radians);
    var nx = (cos * (x - cx)) + (sin * (y - cy)) + cx;
    var ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
    return {x: Math.floor(nx), y: Math.floor(ny) };
  }
  
  function pointInCircle(x, y, cx, cy, r) {
    let [vx, vy] = [x - cx, y - cy];
    return vx*vx+vy*vy < r*r;
  }
    
  function pointOnLine(x, y, p1x, p1y, p2x, p2y) {
    let [v1x, v1y] = [x   - p1x,   y - p1y];
    let [v2x, v2y] = [p2x - p1x, p2y - p1y];
    // Get scalar projection
    let t = (v1x * v2x + v1y * v2y) / (v2x * v2x + v2y * v2y);
    // Check if within boundaries
    if (t < 0 || t > 1)
      return false;
    // Calculate the projected point
    let [px, py] = [p1x + t * v2x, p1y + t * v2y];
    // Calculate position and check if close enough
    return pointInCircle(x, y, px, py, 5) ? [px, py] : false;
  }
    
  function pointInPolygon(x, y, points) {
    let [x1, y1] = [points[points.length-2], points[points.length-1]];
    let [x2, y2] = [points[0], points[1]];
    let inside = false;
    // For every edge, check for an intersection
    for (let i = 0; i < points.length; i+=2) {
      if (((y1 >= y) != (y2 >= y)) && (x < (x2 - x1) * (y - y1) / (y2 - y1) + x1)) {
        inside = !inside;
      }
      [x1, y1] = [x2, y2];
      [x2, y2] = [points[i+2], points[i+3]];
    }
    return inside;
  }
  
  function pointInPolygons(x, y, polygons) {
    let collide = false
    for (let i=0; i<polygons.length; i++) {
      if (pointInPolygon(x, y, polygons[i])) {
        collide = true
        break
      }
    }
    return collide
  }
  
  function projectPolygon(points, x, y, nx, ny) {
    let min = (points[0]-x)*nx+(points[1]-y)*ny;
    let max = min;
    let s;
    for (let i = 2; i < points.length; i+=2) {
      s = (points[i]-x)*nx+(points[i+1]-y)*ny;
      if (s < min) min = s;
      if (s > max) max = s;
    }
    return [min, max];
  }
  
  function polygonCollidesWith(points1, points2) {
    // We project both polygons on all normals of polygon 1
    let [x1, y1] = [points1[points1.length-2], points1[points1.length-1]];
    let [x2, y2] = [points1[0], points1[1]];
    let nx, ny, min1, max1, min2, max2;
    // For every edge of points1
    for (let i = 0; i < points1.length; i+=2) {
      // Get edge normal by rotating the vector [x2-x1, y2-y1] by 90 degrees
      [nx, ny] = [y2-y1, x1-x2];
      // Project both polygons onto the normal
      [min1, max1] = projectPolygon(points1, x2, y1, nx, ny);
      [min2, max2] = projectPolygon(points2, x2, y1, nx, ny);
      // If there is no overlap between the ranges, there is no collision
      if (max1 <= min2 || min1 >= max2)
        return false;
      [x1, y1] = [x2, y2];
      [x2, y2] = [points1[i+2], points1[i+3]];
    }
    return true;
  }
  
  function polygonsCollide(points1, points2) {
    return polygonCollidesWith(points1, points2) && polygonCollidesWith(points2, points1);
  }
  
  function rotateAllPoints (points, ox, oy, angle) {
    let newPoints = []
    for (let i=0; i< points.length-1; i+= 2) {
      let x = points[i]
      let y = points[i+1]
      let { x: nx, y:ny } = rotate(ox, oy, x, y, angle)
      newPoints[i] = nx
      newPoints[i+1] = ny
    }
    return newPoints
  }
  
  function placeFonzie (x, y, radius, npoints, rotation, color, collideCondition = false) {
    const b = 2
    
    const s = 100
  
    radius *= 2
  
    let ipa = rotateAllPoints(polygon(x, y, radius, npoints, rotation, color), x, y, degrees(rotation))
    let opa = rotateAllPoints(polygon(x, y, radius + b, npoints, rotation, color), x, y, degrees(rotation))
   
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], opa)
    }
  
    if (collides == collideCondition) {
      pg.push()
      pg.translate(x, y)
      const img = createImage(s * 2,s)
      img.copy(images[4], 0, 0, s * 2, s, 0, 0, s * 2, s)
      //img.resize(radius * 1.5, radius * 1.5)
      pg.imageMode(CENTER);
      pg.rotate(rotation)
      pg.tint(color)
      pg.image(img, 0, 0)
      pg.pop()
  
      polygons.push(opa)
    }
  
    return !collides
  }
  
  function placeShape (x, y, radius, npoints, rotation, colorA, colorB, colorC, collideCondition = false) {
    const b = 2
    
    let pointsAC = npoints < 0 ? getRndPoints() : npoints
  
    const outline = getOutline(pointsAC)
    const fill = getFill(pointsAC)
  
    let ipa = rotateAllPoints(polygon(x, y, radius, pointsAC, rotation, colorA), x, y, degrees(rotation))
    let opa = rotateAllPoints(polygon(x, y, radius + b, pointsAC, rotation, colorA), x, y, degrees(rotation))
   
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], opa)
    }
  
    if (collides == collideCondition) {
      pg.push()
      pbg.push()
      pg.noStroke()
      pbg.noStroke()
      pg.translate(x, y)
      pbg.translate(x, y)
  
      pg.imageMode(CENTER);
      pbg.imageMode(CENTER);
      pg.rotate(rotation)
      pbg.rotate(rotation)
      
      // outline
      const img = createImage(100,100)
      const bg = createImage(100,100)
  
      //bg.resize(radius * 1.5, radius * 1.5)
  
      img.copy(images[fill], 0, 0, 100, 100, 0, 0, 100, 100)
      // alpha
      // color the item
      if (!psychoLoner) pg.tint(colorA)
      //pg.tint(255, rndNum(130, 60))
      
      // large fill background
      const [r1,g1,b1] = chroma.hex(colorC).rgb()
      pbg.fill(r1,b1,g1,1);
      for(i = 0; i < radius * 3; i++){
        pbg.ellipse(0,0, i*5.2);
      }
  
      // place the loner glow
      const [r2,g2,b2] = chroma.hex(colorB).darken(2).rgb()
      let alpha = .5
      for(i = 0; i < radius * 2; i++){
        //if (alpha > 2) alpha-=1
        pbg.fill(r2,b2,g2,alpha)
        pbg.ellipse(0,0, i*1.75)
      }
  
      
  
      //bg.tint(colorA)
      //pbg.tint(color, 130)
      //bg.copy(images[fill], 0, 0, 100, 100, 0, 0, 100, 100)
      //bg.resize(radius * 1.5, radius * 1.5)
  
  
      //const charAlpha = 0
      //const [r3,g3,b3] = chroma.hex(colorA).rgb()
      //pbg.fill(r3, b3, g3, charAlpha);
      //pbg.image(bg, 0, 0)
      
      //invertImg(pbg)
      //nvertImg(pbg)
  
      img.copy(images[outline], 0, 0, 100, 100, 0, 0, 100, 100)
      img.copy(sadFaces[rndNum(sadFaces.length - 1)], 0, 0, 100, 100, 0, 0, 100, 100)
      img.copy(images[6], 0, 0, 100, 100, 0, 0, 100, 100)
      img.copy(images[7], 0, 0, 100, 100, 0, 0, 100, 100)
      
     
  
      // white outline
      //invertImg(img)
  
      img.resize(radius * 1.5, radius * 1.5)
  
  
      // draw lonliness
      
      if (psychoLoner) {    
        invertImg(img)
        pg.tint(chroma(colorA).brighten(2).hex())
      }
      
      // place shape
      pg.image(img, 0, 0)
  
      pg.pop()
      pbg.pop()
      
  
  
      // place lighting mask
  
      //fg.ellipse(x,y, radius * 5);
      msk.noStroke()
      
      let tr = 99
      for(i = 0; i < radius * 4; i++){
        if (tr > 4) tr-=1
        msk.fill(0,0,0,tr);
        msk.ellipse(x,y, i*5);
      }
      
      
  
      polygons.push(opa)
    }
  
    return !collides
  }
  
  
  const getFill = (points) => (points == 3) ? 1 : ([points] == 4) ? 3 : 5
  const getOutline = (points) => (points == 3) ? 0 : ([points] == 4) ? 2 : 4
  
  
  function placeFlower (x, y, radius, npoints, rotation, color, collideCondition = false) {
    const b = 0
    
    let ipa = rotateAllPoints(polygon(x, y, radius, npoints, rotation, color), x, y, degrees(rotation))
    let opa = rotateAllPoints(polygon(x, y, radius + b, npoints, rotation, color), x, y, degrees(rotation))
   
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], opa)
    }
  
    if (collides == collideCondition) {
      pg.push()
      pg.translate(x, y)
      const img = createImage(25,25)
      img.copy(images[3], 0, 0, 25, 25, 0, 0, 25, 25)
      img.resize(radius * 1.5, radius * 1.5)
      pg.imageMode(CENTER);
      pg.rotate(rotation)
      pg.tint(color)
      pg.image(img, 0, 0)
      pg.pop()
  
      polygons.push(opa)
    }
  }
  
  function getRndPoints () {
    const a = [
      3, 4, 12
    ]
    return a[rndNum(2)]
  }
  
  function placeCouple (x, y, radius, nPointsA, nPointsB, rotation, colors, collideCondition = false) {
    // draw 2 polygons next to each other and rotate relative to the same origin
    // different shapes need different rotation
  
    // if there is space, place a polygon
    const b = 2
    const r = (Math.PI / 6) // triangle
  
    const rotA = r - (fxrand() * 0.1)
    const rotB = r + (fxrand() * 0.1) 
  
    const radius2 = radius - (radius * (fxrand() * 0.4))
  
    const xD = (radius - (radius * .4))
  
  
    let colorA = colors[rndNum(colors.length - 1)]
    let colorB = colors[rndNum(colors.length - 1)]
  
    let pointsAC = nPointsA < 0 ? getRndPoints() : nPointsA
    let pointsBC = nPointsB < 0 ? getRndPoints() : nPointsB
  
    // get points for both shapes rotated about the origin
    let ipa = rotateAllPoints(polygon(x - xD, y, radius, pointsAC, rotA, colorA), x, y, degrees(rotation))
    let ipb = rotateAllPoints(polygon(x + xD, y, radius2, pointsAC, rotB, colorB), x, y, degrees(rotation))
  
    let opa = rotateAllPoints(polygon(x - xD, y, radius + b, pointsBC, rotA, colorA), x, y, degrees(rotation))
    let opb = rotateAllPoints(polygon(x + xD, y, radius2 + b, pointsBC, rotB, colorB), x, y, degrees(rotation))
  
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], opa)
    }
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], opb)
    }
    
    if (collides == collideCondition) {
      const ty = radius * .2
      const ty2 = radius2 * .1
      const tx = 0 // radius * .5
  
      //drawPolygon(ipa, 'red')
      //drawPolygon(ipb, 'blue')
      pg.push()
      pbg.push()
      pg.translate(x, y)
      pbg.translate(x, y)
      const img1 = createImage(100, 100)
      const img2 = createImage(100,100)
      const bg1 = createImage(100, 100)
      const bg2 = createImage(100,100)
  
      const outline1 = getOutline(pointsAC)
      const outline2 = getOutline(pointsBC)
      const fill1 = getFill(pointsAC)
      const fill2 = getFill(pointsBC)
  
      if (!ghostCrowd) bg1.copy(images[fill1], 0, 0, 100, 100, 0, 0, 100, 100)
      img1.copy(images[outline1], 0, 0, 100, 100, 0, 0, 100, 100)
      img1.copy(happyFaces[rndNum(happyFaces.length - 1)], 0, 0, 100, 100, 0, 0, 100, 100)
      img1.copy(images[6], 0, 0, 100, 100, 0, 0, 100, 100)
  
      if (ghostCrowd) invertImg(img1)
  
      if (!ghostCrowd) bg2.copy(images[fill2], 0, 0, 100, 100, 0, 0, 100, 100)
      img2.copy(images[outline2], 0, 0, 100, 100, 0, 0, 100, 100)
      img2.copy(happyFaces[rndNum(happyFaces.length - 1)], 0, 0, 100, 100, 0, 0, 100, 100)
      img2.copy(images[7], 0, 0, 100, 100, 0, 0, 100, 100)
  
      if (ghostCrowd) invertImg(img2)
  
      img1.resize(radius * 1.5, radius * 1.5)
      img2.resize(radius2 * 1.5, radius2 * 1.5)
      bg1.resize(radius * 1.5, radius * 1.5)
      bg2.resize(radius2 * 1.5, radius2 * 1.5)
  
      pg.imageMode(CENTER)
      pbg.imageMode(CENTER)
      pg.rotate(rotation)
      pbg.rotate(rotation)
      //pg.tint(colorA)
      pbg.tint(colorA)
      pg.image(img1, -xD, -ty)
      pbg.image(bg1, -xD, -ty)
      //pg.tint(colorB)
      pbg.tint(colorB)
      pg.image(img2, xD, -ty)
      pbg.image(bg2, xD, -ty)
      pg.pop()
      pbg.pop()
  
      polygons.push(opa)
      polygons.push(opb)
    }
  }
  
  function drawPolygon (points, color) {
    pg.noFill()
      
    pg.beginShape();
  
    for (let i=0; i<points.length; i+=2) {
      pg.strokeWeight(penSize)
      pg.stroke(color)
      pg.vertex(points[i], points[i+1])
    }
    pg.endShape(CLOSE);
  }
  
  function placePolygon (x, y, radius, npoints, rotation, color, collideCondition = false) {
    // if there is space, place a polygon
    const b = 0
    let innerPolygon = polygon(x, y, radius, npoints, rotation, color)
    let outerPolygon = polygon(x, y, radius + b, npoints, rotation, color)
    // rotate all the points  
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = polygonsCollide(polygons[j], outerPolygon)
    }
    
    if (collides == collideCondition) {
      pg.noFill()
      
      pg.beginShape();
  
      for (let i=0; i<innerPolygon.length; i+=2) {
        pg.strokeWeight(penSize)
        pg.stroke(color)
        pg.vertex(innerPolygon[i], innerPolygon[i+1])
      }
      pg.endShape(CLOSE);
      
      let { x:nx, y:ny } = rotate(x, y, x + radius / 4, y, degrees(rotation))
  
      // all circle
      pg.circle(nx, ny, radius / 4);
      polygons.push(outerPolygon)
      //polygonsInners.push(polygon)
    }
  }
  
  function placePoint (x, y, color) {
    let collides = false
    for (let j=0; j<polygons.length; j++) {
      if (collides) return
      collides = pointInPolygon(x, y, polygons[j])
    }
    if (!collides)  {
      pg.stroke(color)
      pg.point(x, y)
    }
    return collides
  }
  
  function polygon(x, y, radius, npoints, rotation, color, collideCondition = false) {
    const ang = 0 //irregular ? rndNum(3) : 0
    let angle = (TWO_PI + ang) / npoints;
    let polygon = []
    for (let a = 0; a < (TWO_PI + ang); a += angle) {
      let sx = x + cos(a + rotation) * radius;
      let sy = y + sin(a + rotation) * radius;
      // now rotate - this is *possibly* a very inefficient way
      polygon.push(sx)
      polygon.push(sy)
    }
    return polygon
  }

export { rotate }
